import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { STATUS_MESSAGE } from "constants";
import { SYSTEM_SENDER_ID } from "constants";
import { TYPE_MESSAGE } from "constants";
import moment from "moment";
import chatService from "services/chat/chatService";

const mess = [
  {
    Content: "Bạn cần tôi hỗ trợ điều gì?",
    Type: TYPE_MESSAGE.TEXT,
    status: STATUS_MESSAGE.DA_GUI,
    CreatedAt: moment(),
    SenderId: SYSTEM_SENDER_ID,
    RoomId: undefined,
    Me: false,
    error: undefined,
    KhoiDau: true,
  },
  {
    Content: "Chào mừng bạn đến với hệ thống hỗ trợ!",
    Type: TYPE_MESSAGE.TEXT,
    status: STATUS_MESSAGE.DA_GUI,
    CreatedAt: moment(),
    SenderId: SYSTEM_SENDER_ID,
    RoomId: undefined,
    Me: false,
    error: undefined,
    KhoiDau: true,
  },
];

export const sendMesages = createAsyncThunk(
  "chat/sendMesages",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await chatService.SendMessage(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMessages = createAsyncThunk(
  "chat/getMessages",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, loadMore } = data;
      const response = await chatService.GetMessages(data);
      const payload = {
        messages: response.messages.messages || [],
        loadMore: loadMore,
        hasMore: response?.messages.hasMore,
      };
      if (onSuccess) onSuccess(payload);
      return payload;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMembers = createAsyncThunk(
  "chat/getMembers",
  async (data, { rejectWithValue }) => {
    try {
      const { Id } = data;
      const response = await chatService.GetMembers(Id);
      return response;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  messages: [],
  hasMore: true,
  members: [],
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addLocalMessage: (state, action) => {
      const { reply } = action.payload;
      const combined = [reply, ...state.messages];
      state.messages = combined;
    },

    updateMessageStatus: (state, action) => {
      const { messageId, newStatus, error } = action.payload;
      const msg = state.messages.find(
        (m) => m.messageId === messageId || m.Id === messageId
      );

      if (msg) {
        msg.status = newStatus;
        msg.error = error;
      }
    },
    addMessageFromAnotherSocket: (state, action) => {
      const msg = action.payload;
      let combined = [...msg, ...state.messages];
      combined.sort((a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt));
      state.messages = combined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMesages.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendMesages.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(sendMesages.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getMessages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.loading = false;
        const { messages: newMessages, loadMore, hasMore } = action.payload;
        state.hasMore = hasMore;
        if (loadMore) {
          const combined = [...state.messages, ...newMessages];
          state.messages = combined;
        } else {
          if (newMessages?.length === 0) {
            state.messages = mess;
          } else state.messages = newMessages;
        }
      })
      .addCase(getMessages.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getMembers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload;
      })
      .addCase(getMembers.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const {
  updateMessageStatus,
  addLocalMessage,
  addMessageFromAnotherSocket,
} = chatSlice.actions;

export default chatSlice.reducer;
